/**
 * 独立页面相关API接口
 */
import request from './request';
import { USE_MOCK } from './config';
/**
 * 获取关于我页面信息
 */
export async function getAboutInfo() {
    if (USE_MOCK) {
        return {
            authorName: '开发者',
            bio: 'Software defines the future',
            content: '### 关于本站\n\n' +
                '**Software defines the future** 是一个个人技术博客，专注于分享:\n\n' +
                '- 后端技术架构\n' +
                '- 前端开发实践\n' +
                '- AI 工具开发\n' +
                '- 软件工程实践\n\n' +
                '### 关于博主\n\n' +
                '热爱编程，喜欢探索新技术，欢迎交流学习。\n\n' +
                '### 技术栈\n\n' +
                '- **后端**: Java Spring Boot + MyBatis Plus + MySQL\n' +
                '- **前端**: Vue 3 + TypeScript + Webpack\n' +
                '- **AI**: 集成大语言模型应用开发\n',
            contacts: [
                { name: 'GitHub', url: 'https://github.com', icon: '🐙' }
            ],
            stats: {
                articleCount: 2,
                categoryCount: 4,
                tagCount: 10,
                totalViews: 1591
            }
        };
    }
    return request.get('/page/about');
}
/**
 * 获取友情链接
 */
export async function getFriendLinks() {
    if (USE_MOCK) {
        return [
            { id: 1, name: 'GitHub', url: 'https://github.com', description: '全球最大的代码托管平台' },
            { id: 2, name: 'Spring Boot', url: 'https://spring.io/projects/spring-boot', description: 'Java应用开发框架' },
            { id: 3, name: 'Vue.js', url: 'https://vuejs.org', description: '渐进式JavaScript 框架' },
            { id: 4, name: 'TypeScript', url: 'https://www.typescriptlang.org', description: 'JavaScript的超集' }
        ];
    }
    return request.get('/page/links');
}
/**
 * 获取归档数据
 */
export async function getArchive() {
    if (USE_MOCK) {
        return {
            byYear: [
                {
                    year: new Date().getFullYear() + '',
                    count: 2,
                    articles: [
                        { id: 1, title: '滕王阁序', date: new Date().toISOString().split('T')[0] },
                        { id: 2, title: '如何开发自己的AI agent', date: new Date().toISOString().split('T')[0] }
                    ]
                }
            ],
            byCategory: [
                {
                    categoryId: 'tech',
                    categoryName: '技术博客',
                    count: 1,
                    articles: [
                        { id: 2, title: '如何开发自己的AI agent', date: new Date().toISOString().split('T')[0] }
                    ]
                },
                {
                    categoryId: 'article',
                    categoryName: '文章赏析',
                    count: 1,
                    articles: [
                        { id: 1, title: '滕王阁序', date: new Date().toISOString().split('T')[0] }
                    ]
                }
            ]
        };
    }
    return request.get('/page/archive');
}
/**
 * 获取归档预览（用于首页侧边栏）
 */
export async function getArchivePreview() {
    if (USE_MOCK) {
        return [
            {
                year: new Date().getFullYear() + '',
                count: 2,
                articles: [
                    { id: 1, title: '滕王阁序', date: new Date().toISOString().split('T')[0] },
                    { id: 2, title: '如何开发自己的AI agent', date: new Date().toISOString().split('T')[0] }
                ]
            }
        ];
    }
    return request.get('/page/archive-preview');
}
/**
 * 获取所有标签列表
 */
export async function getTagList() {
    if (USE_MOCK) {
        return [
            { name: 'Java', count: 2 },
            { name: 'Vue', count: 2 },
            { name: 'TypeScript', count: 2 },
            { name: 'Spring Boot', count: 1 },
            { name: 'MySQL', count: 1 },
            { name: 'AI', count: 1 },
            { name: 'Agent', count: 1 },
            { name: '开发', count: 1 },
            { name: '教程', count: 1 },
            { name: '古文', count: 1 }
        ];
    }
    return request.get('/page/tags');
}
